import _styled from '@emotion/styled-base';
import React, { useEffect, useState, useLayoutEffect } from 'react';
import { useTimer, useIsAuthenticated } from '@dinotechltd/core';
import { navigate } from '@reach/router';

var Style = /*#__PURE__*/_styled("div", {
  target: "e99ehbs0",
  label: "Style"
})("height:", function (props) {
  return props.size ? props.size + "px" : '48px';
}, ";width:", function (props) {
  return props.size ? props.size + "px" : '48px';
}, ";color:", function (props) {
  return props.pathColor ? props.pathColor : 'rgba(90, 90, 90, 0.2)';
}, ";position:relative;display:inline-block;border:5px solid;border-radius:50%;border-right-color:", function (props) {
  return props.color ? props.color : '#5a5a5a';
}, ";animation:rotate 0.6s linear infinite;@keyframes rotate{0%{transform:rotate(0);}100%{transform:rotate(360deg);}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNpcmNsZVBhdGgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV5QiIsImZpbGUiOiJDaXJjbGVQYXRoLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XHJcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcclxuY29uc3QgU3R5bGUgPSBzdHlsZWQuZGl2IGBcbiAgaGVpZ2h0OiAke3Byb3BzID0+IChwcm9wcy5zaXplID8gYCR7cHJvcHMuc2l6ZX1weGAgOiAnNDhweCcpfTtcbiAgd2lkdGg6ICR7cHJvcHMgPT4gKHByb3BzLnNpemUgPyBgJHtwcm9wcy5zaXplfXB4YCA6ICc0OHB4Jyl9O1xuICBjb2xvcjogJHtwcm9wcyA9PiBwcm9wcy5wYXRoQ29sb3IgPyBwcm9wcy5wYXRoQ29sb3IgOiAncmdiYSg5MCwgOTAsIDkwLCAwLjIpJ307XG4gIHBvc2l0aW9uOiByZWxhdGl2ZTtcbiAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICBib3JkZXI6IDVweCBzb2xpZDtcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuICBib3JkZXItcmlnaHQtY29sb3I6ICR7cHJvcHMgPT4gKHByb3BzLmNvbG9yID8gcHJvcHMuY29sb3IgOiAnIzVhNWE1YScpfTtcbiAgYW5pbWF0aW9uOiByb3RhdGUgMC42cyBsaW5lYXIgaW5maW5pdGU7XG4gIEBrZXlmcmFtZXMgcm90YXRlIHtcbiAgICAwJSB7XG4gICAgICB0cmFuc2Zvcm06IHJvdGF0ZSgwKTtcbiAgICB9XG4gICAgMTAwJSB7XG4gICAgICB0cmFuc2Zvcm06IHJvdGF0ZSgzNjBkZWcpO1xuICAgIH1cbiAgfVxuYDtcclxuY29uc3QgQ2lyY2xlUGF0aCA9IChwcm9wcykgPT4ge1xyXG4gICAgcmV0dXJuIFJlYWN0LmNyZWF0ZUVsZW1lbnQoU3R5bGUsIE9iamVjdC5hc3NpZ24oe30sIHByb3BzKSk7XHJcbn07XHJcbmV4cG9ydCBkZWZhdWx0IENpcmNsZVBhdGg7XHJcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUNpcmNsZVBhdGguanMubWFwIl19 */"));

var CirclePath = function CirclePath(props) {
  return React.createElement(Style, Object.assign({}, props));
}; // Text fields must have 16px or larger font size for safari
// not to auto zoom when focused.


var TextField = /*#__PURE__*/_styled("input", {
  target: "ebr8ux90",
  label: "TextField"
})(function (_ref) {
  var hasError = _ref.hasError;
  return hasError && 'border-color: red';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRleHRGaWVsZC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRytCIiwiZmlsZSI6IlRleHRGaWVsZC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XHJcbi8vIFRleHQgZmllbGRzIG11c3QgaGF2ZSAxNnB4IG9yIGxhcmdlciBmb250IHNpemUgZm9yIHNhZmFyaVxyXG4vLyBub3QgdG8gYXV0byB6b29tIHdoZW4gZm9jdXNlZC5cclxuY29uc3QgVGV4dEZpZWxkID0gc3R5bGVkLmlucHV0IGBcbiAgJHsoeyBoYXNFcnJvciB9KSA9PiBoYXNFcnJvciAmJiAnYm9yZGVyLWNvbG9yOiByZWQnfTtcbmA7XHJcblRleHRGaWVsZC5kZWZhdWx0UHJvcHMgPSB7XHJcbiAgICBoYXNFcnJvcjogZmFsc2UsXHJcbn07XHJcbmV4cG9ydCBkZWZhdWx0IFRleHRGaWVsZDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9VGV4dEZpZWxkLmpzLm1hcCJdfQ== */"));

TextField.defaultProps = {
  hasError: false
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Icon = /*#__PURE__*/_styled("svg", {
  target: "e1uxf1i60",
  label: "Icon"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrYm94LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFd0IiLCJmaWxlIjoiQ2hlY2tib3gudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xyXG5jb25zdCBJY29uID0gc3R5bGVkLnN2ZyBgYDtcclxuY29uc3QgU3R5bGVkQ2hlY2tib3ggPSBzdHlsZWQuZGl2IGBcbiAgJHtJY29ufSB7XG4gICAgdmlzaWJpbGl0eTogJHtwcm9wcyA9PiAocHJvcHMuY2hlY2tlZCA/ICd2aXNpYmxlJyA6ICdoaWRkZW4nKX07XG4gIH1cbmA7XHJcbmNvbnN0IENoZWNrYm94ID0gKHsgY2hlY2tlZCwgLi4ucHJvcHMgfSkgPT4gKFJlYWN0LmNyZWF0ZUVsZW1lbnQoXCJkaXZcIiwgbnVsbCxcclxuICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoXCJpbnB1dFwiLCBPYmplY3QuYXNzaWduKHsgY2hlY2tlZDogY2hlY2tlZCB9LCBwcm9wcywgeyB0eXBlOiBcImNoZWNrYm94XCIgfSkpLFxyXG4gICAgUmVhY3QuY3JlYXRlRWxlbWVudChTdHlsZWRDaGVja2JveCwgeyBjaGVja2VkOiBjaGVja2VkIH0sXHJcbiAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChJY29uLCB7IHZpZXdCb3g6IFwiMCAwIDI0IDI0XCIgfSxcclxuICAgICAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChcInBvbHlsaW5lXCIsIHsgcG9pbnRzOiBcIjIwIDYgOSAxNyA0IDEyXCIgfSkpKSkpO1xyXG5leHBvcnQgZGVmYXVsdCBDaGVja2JveDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q2hlY2tib3guanMubWFwIl19 */");

var StyledCheckbox = /*#__PURE__*/_styled("div", {
  target: "e1uxf1i61",
  label: "StyledCheckbox"
})(Icon, "{visibility:", function (props) {
  return props.checked ? 'visible' : 'hidden';
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNoZWNrYm94LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHa0MiLCJmaWxlIjoiQ2hlY2tib3gudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcclxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xyXG5jb25zdCBJY29uID0gc3R5bGVkLnN2ZyBgYDtcclxuY29uc3QgU3R5bGVkQ2hlY2tib3ggPSBzdHlsZWQuZGl2IGBcbiAgJHtJY29ufSB7XG4gICAgdmlzaWJpbGl0eTogJHtwcm9wcyA9PiAocHJvcHMuY2hlY2tlZCA/ICd2aXNpYmxlJyA6ICdoaWRkZW4nKX07XG4gIH1cbmA7XHJcbmNvbnN0IENoZWNrYm94ID0gKHsgY2hlY2tlZCwgLi4ucHJvcHMgfSkgPT4gKFJlYWN0LmNyZWF0ZUVsZW1lbnQoXCJkaXZcIiwgbnVsbCxcclxuICAgIFJlYWN0LmNyZWF0ZUVsZW1lbnQoXCJpbnB1dFwiLCBPYmplY3QuYXNzaWduKHsgY2hlY2tlZDogY2hlY2tlZCB9LCBwcm9wcywgeyB0eXBlOiBcImNoZWNrYm94XCIgfSkpLFxyXG4gICAgUmVhY3QuY3JlYXRlRWxlbWVudChTdHlsZWRDaGVja2JveCwgeyBjaGVja2VkOiBjaGVja2VkIH0sXHJcbiAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChJY29uLCB7IHZpZXdCb3g6IFwiMCAwIDI0IDI0XCIgfSxcclxuICAgICAgICAgICAgUmVhY3QuY3JlYXRlRWxlbWVudChcInBvbHlsaW5lXCIsIHsgcG9pbnRzOiBcIjIwIDYgOSAxNyA0IDEyXCIgfSkpKSkpO1xyXG5leHBvcnQgZGVmYXVsdCBDaGVja2JveDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q2hlY2tib3guanMubWFwIl19 */"));

var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
      props = _objectWithoutPropertiesLoose(_ref, ["checked"]);

  return React.createElement("div", null, React.createElement("input", Object.assign({
    checked: checked
  }, props, {
    type: "checkbox"
  })), React.createElement(StyledCheckbox, {
    checked: checked
  }, React.createElement(Icon, {
    viewBox: "0 0 24 24"
  }, React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }))));
};

var FieldLabel = /*#__PURE__*/_styled("span", {
  target: "e7u3jmf0",
  label: "FieldLabel"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpZWxkTGFiZWwudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUMrQiIsImZpbGUiOiJGaWVsZExhYmVsLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcclxuY29uc3QgRmllbGRMYWJlbCA9IHN0eWxlZC5zcGFuIGBgO1xyXG5leHBvcnQgZGVmYXVsdCBGaWVsZExhYmVsO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1GaWVsZExhYmVsLmpzLm1hcCJdfQ== */");

var FieldError = /*#__PURE__*/_styled("span", {
  target: "etwvd60",
  label: "FieldError"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkZpZWxkRXJyb3IudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUMrQiIsImZpbGUiOiJGaWVsZEVycm9yLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcclxuY29uc3QgRmllbGRFcnJvciA9IHN0eWxlZC5zcGFuIGBgO1xyXG5leHBvcnQgZGVmYXVsdCBGaWVsZEVycm9yO1xyXG4vLyMgc291cmNlTWFwcGluZ1VSTD1GaWVsZEVycm9yLmpzLm1hcCJdfQ== */"); // Text fields must have 16px or larger font size for safari
// not to auto zoom when focused.


var DateField = /*#__PURE__*/_styled("input", {
  target: "ejt6ap00",
  label: "DateField"
})("border:1px solid ", function (_ref) {
  var hasError = _ref.hasError;
  return hasError ? 'red' : 'transparent';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkRhdGVGaWVsZC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRytCIiwiZmlsZSI6IkRhdGVGaWVsZC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XHJcbi8vIFRleHQgZmllbGRzIG11c3QgaGF2ZSAxNnB4IG9yIGxhcmdlciBmb250IHNpemUgZm9yIHNhZmFyaVxyXG4vLyBub3QgdG8gYXV0byB6b29tIHdoZW4gZm9jdXNlZC5cclxuY29uc3QgRGF0ZUZpZWxkID0gc3R5bGVkLmlucHV0IGBcbiAgYm9yZGVyOiAxcHggc29saWQgJHsoeyBoYXNFcnJvciB9KSA9PiAoaGFzRXJyb3IgPyAncmVkJyA6ICd0cmFuc3BhcmVudCcpfTtcbmA7XHJcbmV4cG9ydCBkZWZhdWx0IERhdGVGaWVsZDtcclxuLy8jIHNvdXJjZU1hcHBpbmdVUkw9RGF0ZUZpZWxkLmpzLm1hcCJdfQ== */"));

var Select = /*#__PURE__*/TextField.withComponent('select', {
  target: "e1b3oa6z0",
  label: "Select"
});

var AccessDenied = function AccessDenied(path) {
  var time = useTimer(10, {
    onCompleted: function onCompleted() {
      navigate(path.path);
    }
  });
  return React.createElement("div", null, "Access Denied! Please login to be able to access this content. You'l be redirected to login page in ", time, " sec");
};

var PrivatePage = function PrivatePage(_ref) {
  var children = _ref.children,
      enterPath = _ref.enterPath;

  var _useIsAuthenticated = useIsAuthenticated(),
      isLoading = _useIsAuthenticated.isLoading,
      isLoggedIn = _useIsAuthenticated.isLoggedIn;

  if (isLoading) {
    return React.createElement("div", null, React.createElement(CirclePath, {
      size: 40
    }));
  }

  if (!isLoggedIn) {
    return React.createElement(AccessDenied, {
      path: enterPath
    });
  }

  return React.createElement(React.Fragment, null, children);
};

var CookieDeclaration = function CookieDeclaration() {
  useEffect(function () {
    var script = document.createElement('script');
    script.src = "https://consent.cookiebot.com/" + process.env.COOKIEBOT_CBID + "/cd.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return React.createElement("div", null, React.createElement("div", {
    id: "CookieDeclaration"
  }));
};

var breakpoints = {
  // Legacy  breakpoints.
  oldPhone: '@media (max-width: 320px)',
  phone: '@media (max-width: 500px)',
  iosTableDevice: '@supports (-webkit-overflow-scrolling: touch)',
  phonePortrait: '@media only screen and (orientation:portrait) and (max-width: 500px)',
  tablet: '@media (min-width: 501px) and (max-width: 812px)',
  laptop: '@media (min-width: 813px) and (max-width: 1100px)',
  desktopOrLarger: '@media (min-width: 1100px)',
  tabletOrLarger: '@media (min-width: 501px)',
  laptopOrLarger: '@media (min-width: 813px)',
  tabletOrSmaller: '@media (max-width: 812px)',
  // New breakpoints created with mobile-first approach in mind.
  sm: '@media (min-width: 576px)',
  md: '@media (min-width: 768px)',
  lg: '@media (min-width: 992px)',
  xl: '@media (min-width: 1200px)',
  xsOnly: '@media (max-width: 575px)',
  smOnly: '@media (min-width: 576px) and (max-width: 767px)',
  mdOnly: '@media (min-width: 768px) and (max-width: 991px)',
  lgOnly: '@media (min-width: 992px) and (max-width: 1199px)'
};
var isBrowser = typeof window !== 'undefined';

var useScroll = function useScroll() {
  var _useState = useState(isBrowser ? window.scrollX || window.pageXOffset : 0),
      pageXOffset = _useState[0],
      setPageXOffset = _useState[1];

  var _useState2 = useState(isBrowser ? window.scrollX || window.pageXOffset : 0),
      pageYOffset = _useState2[0],
      setPageYOffset = _useState2[1];

  useLayoutEffect(function () {
    if (typeof window !== 'undefined') {
      var handleScroll = function handleScroll() {
        var scrollX = window.scrollX || window.pageXOffset;
        var scrollY = window.scrollY || window.pageYOffset;
        setPageXOffset(scrollX);
        setPageYOffset(scrollY);
      };

      window.addEventListener('scroll', handleScroll);
      return function () {
        window.removeEventListener('scroll', handleScroll);
      };
    }

    return;
  }, [pageXOffset, pageYOffset]);
  return {
    pageXOffset: pageXOffset,
    pageYOffset: pageYOffset
  };
};

export { AccessDenied, Checkbox, CirclePath, CookieDeclaration, DateField, FieldError, FieldLabel, PrivatePage, Select, TextField, breakpoints, useScroll };